import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderBalanceService {
  isOpenBalancePopover = signal<boolean>(false);
  isOpenWalletPopover = signal<boolean>(false);

  public toggleBalancePopover(action: 'hide' | 'show' | 'toggle' = 'toggle') {
    this.isOpenBalancePopover.update((isOpen) => {
      if (action === 'hide') {
        return false;
      }
      if (action === 'show') {
        return true;
      }
      return !isOpen;
    });
  }

  public toggleWalletPopover(action: 'hide' | 'show' | 'toggle' = 'toggle') {
    this.isOpenWalletPopover.update((isOpen) => {
      if (action === 'hide') {
        return false;
      }
      if (action === 'show') {
        return true;
      }
      return !isOpen;
    });
  }
}
